<app-announcement-bar></app-announcement-bar>

@if (showUI) {
  <app-navbar></app-navbar>
}

<div class="main-container" [ngClass]="{ 'is-scrollup-shown': showScrollUp }">
  <router-outlet></router-outlet>
</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<app-issuer-next-steps-panel></app-issuer-next-steps-panel>

@if (showUI) {
  <app-footer [isExpandFooter]="isExpandFooter"></app-footer>
}

<div
  class="pitchin-icon pitchin-icon-up-arrow"
  [class.mobile-icon]="deviceType != DeviceType.Web"
  [class.m-fadeOut]="!showScrollUp"
  [class.m-fadeIn]="showScrollUp"
  [class.expand-footer]="isExpandFooter"
  [class.above-sticky-bar]="isCampaignSummaryPage"
  (click)="scrollUp()"
></div>

@if (isEquityCampaignPage && isCampaignSuccessfullyFunded === false) {
  <button
    (click)="toggleQuestionBox()"
    class="pitchin-icon-quetions-mark tw-hover:bg-red-800 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-p-4 tw-text-white tw-transition"
    style="
      box-shadow:
        inset 0 0 0 1px #bf2026,
        inset 0 0 0 3px white;
    "
  >
    <span class="tw-text-center tw-text-xl tw-font-bold">?</span>
  </button>
}

@if (showQuestionContent) {
  <div
    #questionBox
    class="tw-fixed tw-bottom-6 tw-left-4 tw-right-4 tw-right-6 tw-z-[999999] tw-cursor-pointer tw-select-none tw-space-y-4 tw-rounded-xl tw-bg-[#2C2C2C] tw-p-4 tw-text-sm tw-text-white tw-shadow-xl sm:tw-bottom-6 sm:tw-left-auto sm:tw-right-6 sm:tw-w-72 sm:tw-p-6"
  >
    <!-- Ask AI Chatbot option -->
    @if (campaignRes?.chatbotUrl) {
      <div
        class="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-p-2 tw-transition hover:tw-bg-[#3a3a3a]"
        (click)="openAIChatbot()"
      >
        <svg class="tw-h-5 tw-w-5" fill="currentColor" viewBox="0 0 24 24">
          <path
            d="M12 2C11.4 2 11 2.4 11 3V4H7C5.3 4 4 5.3 4 7V9H2V15H4V17C4 18.7 5.3 20 7 20H17C18.7 20 20 18.7 20 17V15H22V9H20V7C20 5.3 18.7 4 17 4H13V3C13 2.4 12.6 2 12 2ZM7 6H17C17.6 6 18 6.4 18 7V17C18 17.6 17.6 18 17 18H7C6.4 18 6 17.6 6 17V7C6 6.4 6.4 6 7 6ZM8.5 9C7.7 9 7 9.7 7 10.5C7 11.3 7.7 12 8.5 12C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9ZM15.5 9C14.7 9 14 9.7 14 10.5C14 11.3 14.7 12 15.5 12C16.3 12 17 11.3 17 10.5C17 9.7 16.3 9 15.5 9ZM8 14C7.4 14 7 14.4 7 15C7 15.6 7.4 16 8 16H16C16.6 16 17 15.6 17 15C17 14.4 16.6 14 16 14H8Z"
          />
        </svg>
        <span><strong>Ask AI Chatbot</strong></span>
      </div>
    }
    <div
      class="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-p-2 tw-transition hover:tw-bg-[#3a3a3a]"
      (click)="openAthletesSupport()"
    >
      <img
        src="/assets/img/icons/common/message_icon.png"
        alt="message_icon"
        class="tw-h-5 tw-w-5"
      />
      <span
        ><strong>{{ campaignCompanyName || 'Ask Athletes for Athletes' }}</strong></span
      >
    </div>
    <!-- whatapps button -->
    @if (campaignRes?.whatappsGroupLink) {
      <div
        class="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-p-2 tw-transition hover:tw-bg-[#3a3a3a]"
        (click)="joinWhatsAppGroup()"
      >
        <img
          src="/assets/img/icons/common/whatsapp.png"
          alt="whatsapp_icon"
          class="tw-h-5 tw-w-5"
        />
        <span>Join WhatsApp Group</span>
      </div>
    }
    @if (showScheduleCallButton) {
      <div
        class="tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-p-2 tw-transition hover:tw-bg-[#3a3a3a]"
        (click)="scheduleCall()"
      >
        <img src="/assets/img/icons/common/chatting.png" alt="call_icon" class="tw-h-5 tw-w-5" />
        <span>{{ foundersUrlTitle }}</span>
      </div>
    }
    <!-- email button -->
    <!-- <div
        (click)="openContactFormModal()"
        class="tw-flex tw-items-center tw-gap-3 hover:tw-bg-[#3a3a3a] tw-p-2 tw-rounded-md tw-transition">
        <img src="/assets/img/icons/common/email_icon.png" alt="email_icon" class="tw-w-5 tw-h-5" />
        <span>Send us an Email</span>
      </div> -->
  </div>
}
